import React, { useRef, useState, useLayoutEffect, useEffect } from 'react'
import './styles.scss'
import { OffsetAnnotation } from './offsetAnnotation'
import * as d3 from 'd3-selection'
export const AnnotationLayer = ({
  id,
  imageSrc,
  annotations,
  AnnotationComponent,
  customLineHeight,
  customLinePadding,
  hideArrow = false,
  debug = false,
  lineType = 'flows',
  marker = ['none', 'dot']
}: AnnotationLayer) => {
  annotations.sort((a, b) => {
    return +b.cases - +a.cases
  })
  const [lineHeight, setLineHeight] = useState<number | undefined>(14)
  const linePadding = customLinePadding || 2
  const image = useRef<HTMLImageElement>(null)
  const [svgSize, setSvgSize] = useState<[number, number] | undefined>(
    undefined
  )
  const [locatorPos, setLocatorPos] = useState([0, 0])
  const [viewBox, setviewBox] = useState('0 0 200 200')

  const handleMouseover = (e: MouseEvent) => {
    if (e && e.target) {
      const target = e.target as HTMLElement
      const rect = target.getBoundingClientRect()
      const x = e.clientX - rect.left // x position within the element.
      const y = e.clientY - rect.top
      if (e) {
        if (e.buttons === 0) setLocatorPos([x, y])
      }
    }
  }
  useEffect(() => {
    function updateSize() {
      if (
        image &&
        image !== undefined &&
        image !== null &&
        image.current &&
        !svgSize
      ) {
        setSvgSize([
          image.current.clientWidth || 0,
          image.current.clientHeight || 0
        ])
        setviewBox(
          '0 0 ' + image.current.clientWidth + ' ' + image.current.clientHeight
        )
        if (d3.select('.test').empty()) return
        setLineHeight(
          d3
            .select('.test')
            .node()
            .getBoundingClientRect().height * 0.7
        )
      }
    }
    window.addEventListener('resize', updateSize)

    updateSize()
  }, [image, d3.select('.test').empty()])

  useEffect(() => {
    if (!d3.select('.test').empty()) {
      setLineHeight(
        d3
          .select('.test')
          .node()
          .getBoundingClientRect().height * 0.7
      )
    }
  }, [])
  useEffect(() => {
    if (debug) {
      window.addEventListener('mousemove', handleMouseover)
    }

    return () => window.removeEventListener('mousemove', handleMouseover)
  }, [])

  return (
    <div className='annotationLayer' id={id && id}>
      <img
        src={imageSrc as string}
        ref={image}
        onLoad={() => {
          if (image && image.current) {
            setviewBox(
              '0 0 ' +
                image.current.clientWidth +
                ' ' +
                image.current.clientHeight
            )
            setSvgSize([
              image.current.clientWidth || 0,
              image.current.clientHeight || 0
            ])
          }
        }}
      />
      {svgSize && (
        <svg
          className={debug ? 'debug' : ''}
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
          x='0px'
          y='0px'
          viewBox={viewBox}
          xmlSpace='preserve'
          preserveAspectRatio='xMidYMid meet'
        >
          <defs>
            <marker
              id='arrow'
              viewBox='0 0 10 10'
              refX='5'
              refY='5'
              markerWidth='6'
              markerHeight='6'
              orient='auto-start-reverse'
            >
              <path d='M 0 0 L 10 5 L 0 10 z' />
            </marker>
            <marker
              id='dot'
              viewBox='0 0 10 10'
              refX='5'
              refY='5'
              markerWidth='6'
              markerHeight='6'
              orient='auto-start-reverse'
            >
              <circle cx='5' cy='5' r='2' fill='black' />
            </marker>
          </defs>
          <text className='test' x={100} y={100}>
            <tspan className='bold'>HHHHHH</tspan>
          </text>
          {annotations.map((anno, i) => {
            if (!anno.listonly)
              return (
                <OffsetAnnotation
                  key={i}
                  content={anno}
                  // position={[anno.x, anno.y]}
                  // offset={[anno.offsetX || 0, anno.offsetY || 0]}
                  svgSize={svgSize}
                  // alignOverwrite={anno.align}
                  Comp={AnnotationComponent}
                  lineHeight={lineHeight}
                  linePadding={linePadding}
                  hideArrow={hideArrow}
                  lineType={lineType}
                  marker={marker}
                />
              )
          })}
        </svg>
      )}
      {debug && svgSize && (
        <>
          <div className='center' />
          <div
            className='locator'
            style={{ left: locatorPos[0], top: locatorPos[1] }}
          >
            {((locatorPos[0] * 100) / svgSize[0]).toFixed(1) +
              ',' +
              ((locatorPos[1] * 100) / svgSize[1]).toFixed(1)}
          </div>
        </>
      )}
    </div>
  )
}
